import EventBus from '@ustra/nuxt/src/vue/event-bus'

export interface LayoutDataState {
  /**
   * 타이틀
   */
  title: string

  /**
   * 레이아웃 타입
   */
  layoutType: string

  /**
   * 레이아웃 옵션
   */
  options: any
}

export class LayoutDataEventBus extends EventBus<LayoutDataState> {
  public name(): string {
    // djyoo 21.07.12 빌드 에러로 인해 private > public 으로 임시 수정
    return 'layoutDataEventBus'
  }
}

export default new LayoutDataEventBus()
